import { useCms } from '@eneco/cms';
import RichText from '@eneco/components/RichText/RichText';
import { Checkbox } from '@eneco/sparky';
import { useFormContext, useFormState } from 'react-hook-form';
import { bool } from 'yup';

import type { FormFieldComponent, FormValues } from './types';
import { readFormField, useFormField } from './useFormField';

const ROLE = 'checkboxFormField';
const FALLBACK_NAME = 'checkboxFormField';

const GenericFormCheckboxField: FormFieldComponent = () => {
  const { adapter } = useCms();
  const { register } = useFormContext();
  const { errors } = useFormState<FormValues>();

  const field = useFormField('genericFields', ROLE);
  const name = field.name || FALLBACK_NAME;
  const hint = adapter.toRichText(field.hint);

  return (
    <Checkbox
      error={errors?.[name]?.message as string | undefined}
      hint={hint ? <RichText html={hint} /> : undefined}
      label={field.label ?? ''}
      {...register(name)}
    />
  );
};

// A checkbox is boolean, so `required` alone would reject `false` — `oneOf([true])` is what makes an
// unticked consent box fail with the author's own message.
GenericFormCheckboxField.formSchema = content => {
  const field = readFormField(content, 'genericFields', ROLE);
  const name = field.name || FALLBACK_NAME;
  return { [name]: field.requiredMessage ? bool().oneOf([true], field.requiredMessage) : bool() };
};

export default GenericFormCheckboxField;
